<template>
  <div id="app">
    <div>{{ this.config }}{{ this.checkApiKey() }}</div>
    <Spinners
      v-bind:is-loading="
        this.isLoading || this.$store.get('systems@SpinnersShow')
      "
    ></Spinners>
    <OnlineUser></OnlineUser>
    <OnlineStatus></OnlineStatus>
    <Navbar />
    <router-view class="router" />
    <!-- CSS animation example -->
    <notifications
      group="notifi-main-top-right"
      position="top right"
      animation-name="v-fade-left"
      :speed="500"
    >
    </notifications>

    <b-modal
      v-model="this.snackWithButtons"
      id="modal-new-version"
      ref="modal-new-version"
      title="New Version Update !"
      :no-close-on-backdrop="true"
      :close-on-esc="true"
      hide-footer
    >
      <!-- 
      <template v-slot:modal-header="{ close }">
        <h5>New Version Update</h5>
      </template> -->

      <b-alert show variant="warning" class="margin-bottom">
        <div>
          New content is available; Waiting refresh. !
          <!--
          <b-button
            size="sm"
            type="submit"
            variant="danger"
            @click="refreshApp"
          >
            Click Refresh App.
          </b-button> -->
        </div>
      </b-alert>
    </b-modal>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar"; // @ is an alias to /src
import Spinners from "@/components/Spinners";
import store from "@/store/store";
// import velocity from 'velocity-animate'
// import PatientData from './models/PatientData'
import { sync } from "vuex-pathify";
import { config } from "@vue/test-utils";
import router from "@/router/router";
import axios from "axios";
// import ConfigData from "@/config/config";

// import ConfigData from "../config/config";
import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";
import VueSession from "vue-session";

// const ConfigData = require("../config/config.json");
import OnlineStatus from "@/components/OnlineStatus";
import OnlineUser from "@/components/OnlineUser";

import dotenv from "dotenv";

require("dotenv").config();

const cryptoJSON = require("crypto-json");
const algorithm = "camellia-128-cbc";
const encoding = "hex";

Vue.use(VueSession);

@Component({
  data() {
    return {
      refreshing: false,
      registration: null,
      snackBtnText: "",
      snackWithBtnText: "",
      snackWithButtons: false,
      timeout: 0,
      HGscrollY: false,
      loadStatus: false,
      refCount: 0,
      isLoading: false,
      config: null,
      setConfig: false,
      timeSTD: 0,
      darkMode: true,
      apiKeyCk: ""
    };
  },
  components: {
    Navbar,
    Spinners,
    // ConfigData,
    PatientWebbaseUrl,
    OnlineStatus,
    OnlineUser
    // velocity,
    // PatientData,
  },
  computed: {
    // @see https://davestewart.github.io/vuex-pathify/#/api/component
    ...sync("*")
  },
  plugin: {
    // velocity,
  },
  created() {
    this.startConfig();

    // console.log("LL", window.__env.api);

    // ).then(r => (this.config = r.default)); // "./config/appConfig.json" // import(

    /*
    window.addEventListener(
      "beforeunload",
      () => {
        //I CAN ACCESS TO this VARIABLE
        alert("bbbbbbbbbbbb");
        console.log(this.anything);
      },
      false
    );
    */ /* webpackChunkName: "config", webpackMode: "lazy-once" */ window.addEventListener(
      "resize",
      this.handleResize
    );
    this.handleResize();

    // this.SetApiURL();
    // this.setCompanyId();

    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      setTimeout(() => {
        window.location.reload(true);
      }, 3000);
    });

    /** axios Spinners Status Load Data */
    axios.interceptors.request.use(
      config => {
        this.setLoading(true);
        // store.set('systems@SpinnersSTD', true)
        return config;
      },
      error => {
        this.setLoading(false);
        // store.set('systems@SpinnersSTD', false)
        return Promise.reject(error);
      }
    );

    /** axios Spinners Status Load Data */

    axios.interceptors.response.use(
      response => {
        setTimeout(() => {
          this.setLoading(false);
        }, 1000);

        if (this.$store.get("systems@LoginStatus")) {
          this.setDateTimeUseApp();
        }
        // store.set('systems@SpinnersSTD', false)
        return response;
      },
      error => {
        setTimeout(() => {
          this.setLoading(false);
        }, 1000);

        // store.set('systems@SpinnersSTD', false)
        return Promise.reject(error);
      }
    );
  },
  destroyed() {
    localStorage.ApiKey = "";
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.darkMode = localStorage.getItem("theme");

    /*
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "/src/config/config.js");
    document.head.appendChild(recaptchaScript);

    console.log("ssss", recaptchaScript);
    */

    this.CheckTimeOut();
    // store.set("systems@UUID", this.$uuid.v1());
  },
  watch: {
    apiKeyCk: function() {
      this.loadMophApiImmigrationGetToken();
      this.loadEverApiImmigrationGetToken();
    }
  },
  methods: {
    checkApiKey() {
      if (this.apiKeyCk !== this.$store.get("systems@ApiKey")) {
        this.apiKeyCk = this.$store.get("systems@ApiKey");
      }
    },
    setDateTimeUseApp() {
      let tnow = new Date();

      let Days = "";
      let Months = "";
      let Hours = "";
      let Minutes = "";
      let Seconds = "";

      if (tnow.getDate().toString().length == 1) {
        Days = "0" + tnow.getDate().toString();
      } else {
        Days = tnow.getDate().toString();
      }

      if ((tnow.getMonth() + 1).toString().length == 1) {
        Months = "0" + (tnow.getMonth() + 1).toString();
      } else {
        Months = (tnow.getMonth() + 1).toString();
      }

      let DateNow = tnow.getFullYear() + "-" + Months + "-" + Days;

      if (tnow.getHours().toString().length == 1) {
        Hours = "0" + tnow.getHours().toString();
      } else {
        Hours = tnow.getHours().toString();
      }

      if (tnow.getMinutes().toString().length == 1) {
        Minutes = "0" + tnow.getMinutes().toString();
      } else {
        Minutes = tnow.getMinutes().toString();
      }

      if (tnow.getSeconds().toString().length == 1) {
        Seconds = "0" + tnow.getSeconds().toString();
      } else {
        Seconds = tnow.getSeconds().toString();
      }

      let DDTT = DateNow + " " + Hours + ":" + Minutes + ":" + Seconds;

      let LgData = this.$store.get("systems@LoginData");

      LgData.DID = DDTT;

      store.set("systems@LoginData", LgData);

      const password = "hisSMPK10685";
      const input = { DID: DDTT };

      const algorithm = "aes256";
      const encoding = "hex";
      const keys = ["DID"];

      const output = cryptoJSON.encrypt(input, password, {
        encoding,
        keys,
        algorithm
      });

      let kk = this.$session.get("LoginData");

      kk.DID = output.DID;

      this.$session.set("LoginData", kk);
    },
    SignOut() {
      let currentObj = this;
      store.set("systems@LoginStatus", false);
      store.set("systems@LoginData", []);
      store.set("systems@ApiKey", "");
      this.$session.destroy();
      currentObj.show = false;
    },
    CheckTimeOut() {
      if (this.$store.get("systems@LoginStatus")) {
        this.timeSTD = this.DateTimeDiff(
          this.$store.get("systems@LoginData").DID
        );

        if (this.timeSTD > 60) {
          this.SignOut();
        }
      }

      setTimeout(() => {
        this.CheckTimeOut();
      }, 1000);
    },
    DateTimeDiff(ds) {
      let eventStartTime = new Date(ds.replace(" ", "T"));
      let eventEndTime = new Date();
      let duration = eventEndTime.valueOf() - eventStartTime.valueOf();
      duration = duration / 1000 / 60;
      return duration;
    },
    startConfig() {
      if (window.__env.api && !this.setConfig) {
        this.setConfig = true;
        this.SetApiURL();
        this.setCompanyId();
      }
    },
    showRefreshUI(e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.snackBtnText = "Refresh";
      this.snackWithBtnText = "New version available!";
      this.snackWithButtons = true;
    },
    refreshApp() {
      this.snackWithButtons = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");

      if (this.refreshing) return;
      this.refreshing = true;
      setTimeout(() => {
        window.location.reload(true);
      }, 2000);
    },

    /** axios Spinners Status Load Data */
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.isLoading = true;
        // store.set('systems@SpinnersSTD', true)
      } else if (this.refCount > 0) {
        this.refCount--;
        this.isLoading = this.refCount > 0;
      }
    },
    SetApiURL() {
      store.set("systems@anLoad", false);
      store.set("systems@SpinnersShow", false);
      store.set("systems@SearchPT", false);
      store.set("systems@SearchPTid", "");
      store.set("systems@token_key", window.__env.api.IPFS_TOKEN_KEY);
      store.set(
        "systems@BLOOD_GROUP_LAB_REPORT",
        window.__env.api.BLOOD_GROUP_LAB_REPORT
      );
      store.set("systems@IPFS_USE", window.__env.api.IPFS_USE);

      store.set("systems@PAC_ONLINE", window.__env.api.PAC_ONLINE); 

      store.set("systems@VACCINE_COVID", window.__env.api.VACCINE_COVID);

      store.set(
        "systems@LAB_REPORT_OUT_LINK",
        window.__env.api.LAB_REPORT_OUT_LINK
      );
      store.set(
        "systems@XRAY_REPORT_OUT_LINK",
        window.__env.api.XRAY_REPORT_OUT_LINK
      );

      // store.set('systems@SpinnersSTD', false)

      if (process.env.NODE_ENV === "development") {
        store.set("systems@UrlApi", window.__env.api.ROOT_API_DEV);
        store.set("systems@IpfsUrlApi", window.__env.api.IPFS_API_DEV);
      } else {
        store.set("systems@UrlApi", window.__env.api.ROOT_API_PRO);
        store.set("systems@IpfsUrlApi", window.__env.api.ROOT_API_PRO);
      }

      setTimeout(() => {
        if (
          this.$store.get("systems@ApiKey") != "undefined" &&
          this.$store.get("systems@ApiKey") != undefined &&
          this.$store.get("systems@ApiKey") != "" &&
          this.$store.get("systems@ApiKey") != null
        ) {
          // console.log(this.$store.get("systems@ApiKey"));
          // this.loadMophApiImmigrationGetToken();
          // this.loadEverApiImmigrationGetToken();
        }
      }, 1000);
    },
    setCompanyId() {
      store.set("systems@CompanyId", window.__env.api.CompanyId);
    },
    handleResize() {
      // store.commit('setPageWidth', window.innerWidth)
      // store.commit('setPageHeight', window.innerHeight)
      store.set("systems@PageWidth", window.innerWidth);
      store.set("systems@PageHeight", window.innerHeight);
    },
    handleScroll() {
      let scrollY = window.scrollY;
      let scrollX = window.scrollX;
      // store.commit('setScrollY', scrollY)
      // store.commit('setScrollX', scrollX)
      // scrollY >= 20 ? store.commit('setScrollChangColor', true) : store.commit('setScrollChangColor', false)
      /*
        store.set('systems@scrollY', scrollY)
        store.set('systems@scrollX', scrollX)
        */

      if (scrollY >= 20 && this.HGscrollY == false) {
        this.HGscrollY = true;
        // if(this.$store.get('systems@scrollChangColor') != true){
        // store.set('systems@scrollChangColor', true)
        // }
      }

      if (scrollY < 20 && this.HGscrollY == true) {
        this.HGscrollY = false;
        // if(this.$store.get('systems@scrollChangColor') == true){
        // store.set('systems@scrollChangColor', false)
        // }
      }

      // scrollY >= 20 ? store.set('systems@scrollChangColor', true) : store.set('systems@scrollChangColor', false)
    },
    handleOnlineTrue() {
      // store.commit('setOnlineStatus', true)
      store.set("systems@onlineStatus", true);
    },
    handleOnlineFalse() {
      // store.commit('setOnlineStatus', false)
      store.set("systems@onlineStatus", false);
    },

    loadMophApiImmigrationGetToken() {
      let DataLoadObj = this;
      let data = [];
      let val = null;
      let st = "Y";

      // #### Moph api immigration get token ####
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "moph-api-immigration-get-token",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey")
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          // console.log("sss", DataLoadObj.output);
          if (DataLoadObj.output.status === true) {
            if (DataLoadObj.output.result.use_status != "") {
              store.set("systems@mophUser", DataLoadObj.output.result);
            }
            if (DataLoadObj.output.result.use_status == "N") {
              st = DataLoadObj.output.result.use_status;
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Moph api immigration get token : " + DataLoadObj.output);
        })
        .finally(function() {
          DataLoadObj.$store.get("systems@mophUser");
          if (st == "N") {
            DataLoadObj.loadMophApiImmigrationGenToken();
          }
        });
    },

    loadMophApiImmigrationGenToken() {
      let DataLoadObj = this;
      let data = [];
      let val = null;
      let password = this.$store.get("systems@mophUser").moph_password;
      let username = this.$store.get("systems@mophUser").moph_username;
      let mophData = null;

      // #### Moph api immigration ####
      this.axios
        .post(
          "https://smarthealth.service.moph.go.th/phps/public/api/v3/gettoken",
          {
            password: password,
            username: username
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.jwt_token !== "") {
            mophData = DataLoadObj.output;
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Moph api immigration : " + DataLoadObj.output);
        })
        .finally(function() {
          if (mophData !== null && mophData !== "") {
            DataLoadObj.loadMophApiImmigrationPostToken(mophData);
          }
        });
    },

    loadMophApiImmigrationPostToken(mophData) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### moph-api-immigration-post-token ####

      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "moph-api-immigration-post-token",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            mophData: mophData
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            if (DataLoadObj.output.result.use_status !== "") {
              store.set("systems@mophUser", DataLoadObj.output.result);
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Moph api immigration get token : " + DataLoadObj.output);
        });
    },

    loadEverApiImmigrationGetToken() {
      let DataLoadObj = this;
      let data = [];
      let val = null;
      let st = "Y";

      // #### Moph api immigration get token ####
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "ever-api-immigration-get-token",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey")
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          // console.log("sss", DataLoadObj.output);
          if (DataLoadObj.output.status === true) {
            if (DataLoadObj.output.result.use_status != "") {
              store.set("systems@EverUser", DataLoadObj.output.result);
            }
            if (DataLoadObj.output.result.use_status == "N") {
              st = DataLoadObj.output.result.use_status;
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Ever api immigration get token : " + DataLoadObj.output);
        })
        .finally(function() {
          // console.log("PP", st);
          DataLoadObj.$store.get("systems@EverUser");
          if (st == "N") {
            DataLoadObj.loadEverApiImmigrationGenToken();
          }
        });
    },

    loadEverApiImmigrationGenToken() {
      let DataLoadObj = this;
      let data = [];
      let val = null;
      let password = this.$store.get("systems@EverUser").ever_password;
      let username = this.$store.get("systems@EverUser").ever_username;
      let mophData = null;

      // #### Ever api immigration ####
      this.axios
        .post("https://api.refer.evernetwork.io/external/api/auth/login", {
          password: password,
          username: username
        })
        .then(function(response) {
          DataLoadObj.output = response.data;

          if (DataLoadObj.output.token !== "") {
            mophData = DataLoadObj.output;
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Ever api immigration : " + DataLoadObj.output);
        })
        .finally(function() {
          if (mophData !== null && mophData !== "") {
            DataLoadObj.loadEverApiImmigrationPostToken(mophData);
          }
        });
    },

    loadEverApiImmigrationPostToken(mophData) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### moph-api-immigration-post-token ####

      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "ever-api-immigration-post-token",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            mophData: mophData
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            if (DataLoadObj.output.result.use_status !== "") {
              store.set("systems@EverUser", DataLoadObj.output.result);
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Ever api immigration get token : " + DataLoadObj.output);
        });
    }
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
})
export default class App extends Vue {}

/*
  export default {
    components: {
      'Navbar': Navbar
    }
  }
  */
</script>

<style lang="scss">
// @import './scss/main.scss';

div.offline-indicator {
  background: red;
  color: white;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #fef1ea;
  padding-top: 50px;
}

.router {
  padding: 10px 10px 2px 10px;
  text-align: center;
}

#modal-new-version {
  background: rgba(15, 24, 31, 0.95) !important;
}
</style>

